import React, { useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import FormInput from 'components/Input/FormInput';

export const NameDishInput: React.FC = React.memo(() => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterDishName') }], [t]);

	return (
		<FormInput
			testId="NameDishInput"
			name="nameOfDish"
			label="dishLabel"
			validationRules={validationRules}
			maxLength={100}
			disabled={true}
		/>
	);
});
